import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-admin-route-instance-management',
  imports: [RouterModule],
  templateUrl: './admin-route-instance-management.html',
  styleUrl: './admin-route-instance-management.scss',
})
export class AdminRouteInstanceManagement {}
